import { useContext, ComponentProps } from 'react';
import clsx from 'clsx';
import { OpInput } from 'components/customAntd/DLS/OpInput/OpInput';
import { OpSkeleton } from 'components/customAntd/DLS/OpSkeleton/OpSkeleton';
import { OpFormContext } from '../../OpFormContext';
import { OpForm } from '../../OpForm';

interface IOpFormPasswordInput
  extends Pick<
      ComponentProps<typeof OpForm.Item>,
      | 'name'
      | 'label'
      | 'tooltip'
      | 'rules'
      | 'validateTrigger'
      | 'validateStatus' // Temp: For SUIR wrapped version
      | 'help' // Temp: For SUIR wrapped version
      | 'required' // Temp: For SUIR wrapped version
    >,
    Omit<ComponentProps<typeof OpInput.Password>, 'name' | 'required'> {
  formItemClassName?: string;
  isLoading?: boolean;
}

export const OpFormPasswordInput = ({
  // Form Item props
  formItemClassName,
  name,
  label,
  tooltip,
  rules,
  validateTrigger,
  required, // TEMP: For old form component validation
  validateStatus, // TEMP: For old form component validation
  help, // TEMP: For old form component validation

  // For skeleton loading state
  isLoading,

  // Wrapped element props
  disabled,

  ...elementProps
}: IOpFormPasswordInput) => {
  /** The Form is wrapped in a provider that passes the loading and readOnly
   * contexts to the component */
  const { isDataLoading, isReadOnly } = useContext(OpFormContext);

  return (
    <OpForm.Item
      className={clsx('op-form-password-input', formItemClassName)}
      name={name}
      label={label}
      tooltip={tooltip}
      rules={rules}
      validateTrigger={validateTrigger}
      required={required} // TEMP: For old form component validation
      validateStatus={validateStatus} // TEMP: For old form component validation
      help={help} // TEMP: For old form component validation
    >
      {isDataLoading || isLoading ? (
        /** A placeholder in the shape of the component
         * so we can immediately render the structure of the form while
         * data is loading */
        <OpSkeleton.Input active block />
      ) : (
        /** The actual component that is rendered when we have the data */
        <OpInput.Password disabled={isReadOnly || disabled} {...elementProps} />
      )}
    </OpForm.Item>
  );
};
